// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 0.5C13.1905 0.5 14.2406 1.09427 14.8724 2H21.5V22H2.5V2H9.12759C9.75936 1.09427 10.8095 0.5 12 0.5ZM10.5864 16.6569L17.6575 9.58584L16.2432 8.17163L10.5864 13.8285L7.75796 11.0001L6.34375 12.4143L10.5864 16.6569Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-assignment-checked-filled')
export default class AssignmentCheckedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'assignment-checked-filled',
    }
  }
}
